import { render, staticRenderFns } from "./SocialIdNumber.vue?vue&type=template&id=09da9634&"
import script from "./SocialIdNumber.vue?vue&type=script&lang=js&"
export * from "./SocialIdNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports